// About Section Data
import { SectionHeader, Card } from '../data/schemas';

export const aboutData = {
  header: new SectionHeader("Get To Know", "About Me", "about"),
  
  cards: [
    new Card('FaMobileAlt', 'Software Engineer', 'Mobile & Web Development', 'react-icons/fa'),
    new Card('FaProjectDiagram', 'Program Coordinator', 'Tech Education & Training', 'react-icons/fa'),
    new Card('FaGraduationCap', 'Computer Engineer', 'BSc Systems Engineering', 'react-icons/fa'),
    new Card('FaUsers', 'IEEE Leader', 'Vice Chair & Treasurer', 'react-icons/fa'),
    new Card('FaChalkboardTeacher', 'Technical Trainer', 'JavaScript & Development', 'react-icons/fa'),
    new Card('FaRocket', 'Innovation Focus', 'Tech Solutions & Growth', 'react-icons/fa'),
  ]
};
